import React, { useState } from 'react'
import classnames from 'classnames'
import ActionDropdown from '@SiteComponents/ActionDropdown'
import More from '@Images/projects_table_list_more.svg'

import {
  ILabel,
} from '@SiteModules/Label/types'

import {
  IOpenDeleteLabelPopupPayload,
  IOpenRenameLabelPopupPayload,
} from '@SiteModules/Popup/types'

import './LabelRow.scss'

interface LabelRowProps {
  readonly index: number
  readonly label: ILabel
  openDeleteLabelPopup(payload: IOpenDeleteLabelPopupPayload): void
  openRenameLabelPopup(payload: IOpenRenameLabelPopupPayload): void
}

const LabelRow: React.FC<LabelRowProps> = props => {
  const {
    index,
    label,
  } = props

  const {
    id,
    attributes,
  } = label

  const {
    caption,
    createdAt,
    updatedAt,
    projectIds,
  } = attributes

  const [showDropdown, setShowDropdown] = useState(false)

  const moreElementId = `label_row_more_${id}`
  const classNameForClickOutsideListenerMoreDropdown = `LabelsTable__action-dropdown-element-${id}`
  const useInProjects = projectIds.length

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const handleOpenDeleteLabelPopup = () => {
    props.openDeleteLabelPopup({ labelId: id, caption })
    setShowDropdown(false)
  }

  const handleOpenRenameLabelPopup = () => {
    props.openRenameLabelPopup({ labelId: id, caption })
    setShowDropdown(false)
  }

  const renderTitle = () => {
    return (
      <div className="LabelRow__name">
        {caption}
      </div>
    )
  }

  const actionDropdownList = (
    <ul>
      <li
        className="LabelsTable__action-dropdown-item"
        onClick={handleOpenDeleteLabelPopup}
      >
        <div className="LabelsTable__action-dropdown-item-text">
          Delete label
        </div>
      </li>
      <li
        className="LabelsTable__action-dropdown-item"
        onClick={handleOpenRenameLabelPopup}
      >
        <div className="LabelsTable__action-dropdown-item-text">
          Rename label
        </div>
      </li>
    </ul>
  )

  const renderActionDropdown = () => {
    return (
      <ActionDropdown
        showDropdown={showDropdown}
        dropdownList={actionDropdownList}
        classNamesForListContainer="LabelsTable__action-dropdown"
        classNameForClickOutsideListener={classNameForClickOutsideListenerMoreDropdown}
        classNameOfScrollContainer="LabelsTableList"
        idOfDropdownElement={moreElementId}
        idOfPortalContainer="labels"
        dropdownOffsetX={45}
        dropdownOffsetY={0}
        dropdownWidth={209}// same width as LabelsTable__action-dropdown
        setShowDropdown={setShowDropdown}
      />
    )
  }

  return (
    <tr
      className={classnames(
        { 'LabelRow__even': index % 2 === 0 },
        { 'LabelRow__uneven': index % 2 === 1 }
      )}
    >
      <td className="LabelsTableList__name LabelRow__name">
        <div className="LabelRow__name-wrapper">
          {renderTitle()}
        </div>
      </td>
      <td className="LabelsTableList__use-in-projects LabelRow__use-in-projects">
        {useInProjects === 1 ? '1 time' : `${useInProjects} times`}
      </td>
      <td className="LabelsTableList__created LabelRow__created">
        {createdAt}
      </td>
      <td className="LabelsTableList__edited LabelRow__edited">
        {updatedAt}
      </td>

      <td className="LabelsTableList__more LabelRow__more">
        <div
          className={`LabelRow__more-wrapper ${classNameForClickOutsideListenerMoreDropdown}`}
          id={moreElementId}
        >
          <More
            onClick={toggleDropdown}
          />
          {showDropdown && renderActionDropdown()}
        </div>
      </td>
    </tr>
  )
}

export default LabelRow
